import { render, staticRenderFns } from "./ReferralComponent.vue?vue&type=template&id=652748a0"
import script from "./ReferralComponent.vue?vue&type=script&lang=js"
export * from "./ReferralComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports